'use strict';

var _excluded = ["strengthMultiplier", "verticalStrength", "horizontalStrength", "onScrollChange"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var jsxRuntime = require('react/jsx-runtime');

var react = require('react');

var hoist = require('hoist-non-react-statics');

var throttle = require('lodash.throttle');

var reactDnd = require('react-dnd');

function _interopDefaultLegacy(e) {
  return e && _typeof(e) === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var hoist__default = /*#__PURE__*/_interopDefaultLegacy(hoist);

var throttle__default = /*#__PURE__*/_interopDefaultLegacy(throttle);

var noop = function noop() {};

var intBetween = function intBetween(min, max, val) {
  return Math.floor(Math.min(max, Math.max(min, val)));
};

var getCoords = function getCoords(evt) {
  if (evt.type === 'touchmove') {
    return {
      x: evt.changedTouches[0].clientX,
      y: evt.changedTouches[0].clientY
    };
  }

  return {
    x: evt.clientX,
    y: evt.clientY
  };
};

var DEFAULT_BUFFER = 150;

var createHorizontalStrength = function createHorizontalStrength(_buffer) {
  return function (_ref, point) {
    var x = _ref.x,
        w = _ref.w,
        y = _ref.y,
        h = _ref.h;
    var buffer = Math.min(w / 2, _buffer);
    var inRange = point.x >= x && point.x <= x + w;
    var inBox = inRange && point.y >= y && point.y <= y + h;

    if (inBox) {
      if (point.x < x + buffer) {
        return (point.x - x - buffer) / buffer;
      }

      if (point.x > x + w - buffer) {
        return -(x + w - point.x - buffer) / buffer;
      }
    }

    return 0;
  };
};

var createVerticalStrength = function createVerticalStrength(_buffer) {
  return function (_ref2, point) {
    var y = _ref2.y,
        h = _ref2.h,
        x = _ref2.x,
        w = _ref2.w;
    var buffer = Math.min(h / 2, _buffer);
    var inRange = point.y >= y && point.y <= y + h;
    var inBox = inRange && point.x >= x && point.x <= x + w;

    if (inBox) {
      if (point.y < y + buffer) {
        return (point.y - y - buffer) / buffer;
      }

      if (point.y > y + h - buffer) {
        return -(y + h - point.y - buffer) / buffer;
      }
    }

    return 0;
  };
};

var defaultHorizontalStrength = createHorizontalStrength(DEFAULT_BUFFER);
var defaultVerticalStrength = createVerticalStrength(DEFAULT_BUFFER);
var defaultProps = {
  onScrollChange: noop,
  verticalStrength: defaultVerticalStrength,
  horizontalStrength: defaultHorizontalStrength,
  strengthMultiplier: 30
};

var createScrollingComponent = function createScrollingComponent(WrappedComponent) {
  var ScrollingComponent = function ScrollingComponent(props) {
    props = _objectSpread(_objectSpread({}, defaultProps), props);
    var container;
    var wrappedInstance = react.createRef();
    var frame;
    var scaleX = 0;
    var scaleY = 0;
    var attached = false;
    var dragging = false;
    var updateScrolling = throttle__default["default"](function (evt) {
      var _container$getBoundin = container.getBoundingClientRect(),
          x = _container$getBoundin.left,
          y = _container$getBoundin.top,
          w = _container$getBoundin.width,
          h = _container$getBoundin.height;

      var box = {
        x: x,
        y: y,
        w: w,
        h: h
      };
      var coords = getCoords(evt);
      scaleX = props.horizontalStrength(box, coords);
      scaleY = props.verticalStrength(box, coords);

      if (!frame && (scaleX || scaleY)) {
        startScrolling();
      }
    }, 100, {
      trailing: false
    });
    react.useEffect(function () {
      container = wrappedInstance.current;

      if (container && typeof container.addEventListener === 'function') {
        container.addEventListener('dragover', handleEvent);
      }

      window.document.body.addEventListener('touchmove', handleEvent);
      var clearMonitorSubscription = props.dragDropManager.getMonitor().subscribeToStateChange(function () {
        return handleMonitorChange();
      });
      return function () {
        if (container && typeof container.removeEventListener === 'function') {
          container.removeEventListener('dragover', handleEvent);
        }

        window.document.body.removeEventListener('touchmove', handleEvent);
        clearMonitorSubscription();
        stopScrolling();
      };
    }, []);

    var handleEvent = function handleEvent(evt) {
      if (dragging && !attached) {
        attach();
        updateScrolling(evt);
      }
    };

    var handleMonitorChange = function handleMonitorChange() {
      var isDragging = props.dragDropManager.getMonitor().isDragging();

      if (!dragging && isDragging) {
        dragging = true;
      } else if (dragging && !isDragging) {
        dragging = false;
        stopScrolling();
      }
    };

    var attach = function attach() {
      attached = true;
      window.document.body.addEventListener('dragover', updateScrolling);
      window.document.body.addEventListener('touchmove', updateScrolling);
    };

    var detach = function detach() {
      attached = false;
      window.document.body.removeEventListener('dragover', updateScrolling);
      window.document.body.removeEventListener('touchmove', updateScrolling);
    };

    var startScrolling = function startScrolling() {
      var i = 0;

      var tick = function tick() {
        if (props.strengthMultiplier === 0 || scaleX + scaleY === 0) {
          stopScrolling();
          return;
        }

        i += 1;

        if (i % 2) {
          var _container = container,
              scrollLeft = _container.scrollLeft,
              scrollTop = _container.scrollTop,
              scrollWidth = _container.scrollWidth,
              scrollHeight = _container.scrollHeight,
              clientWidth = _container.clientWidth,
              clientHeight = _container.clientHeight;
          var newLeft = scaleX ? container.scrollLeft = intBetween(0, scrollWidth - clientWidth, scrollLeft + scaleX * props.strengthMultiplier) : scrollLeft;
          var newTop = scaleY ? container.scrollTop = intBetween(0, scrollHeight - clientHeight, scrollTop + scaleY * props.strengthMultiplier) : scrollTop;
          props.onScrollChange(newLeft, newTop);
        }

        frame = requestAnimationFrame(tick);
      };

      tick();
    };

    var stopScrolling = function stopScrolling() {
      detach();
      scaleX = 0;
      scaleY = 0;

      if (frame) {
        cancelAnimationFrame(frame);
        frame = undefined;
      }
    };

    var _props = props,
        strengthMultiplier = _props.strengthMultiplier,
        verticalStrength = _props.verticalStrength,
        horizontalStrength = _props.horizontalStrength,
        onScrollChange = _props.onScrollChange,
        other = _objectWithoutProperties(_props, _excluded);

    return jsxRuntime.jsx(WrappedComponent, _objectSpread({
      ref: wrappedInstance
    }, other));
  };

  return hoist__default["default"](ScrollingComponent, WrappedComponent);
};

var createScrollingComponentWithConsumer = function createScrollingComponentWithConsumer(WrappedComponent) {
  var ScrollingComponent = createScrollingComponent(WrappedComponent);
  return function (props) {
    return jsxRuntime.jsx(reactDnd.DndContext.Consumer, {
      children: function children(_ref3) {
        var dragDropManager = _ref3.dragDropManager;
        return dragDropManager === undefined ? undefined : jsxRuntime.jsx(ScrollingComponent, _objectSpread(_objectSpread({}, props), {}, {
          dragDropManager: dragDropManager
        }));
      }
    });
  };
};

exports.createHorizontalStrength = createHorizontalStrength;
exports.createScrollingComponent = createScrollingComponent;
exports.createVerticalStrength = createVerticalStrength;
exports["default"] = createScrollingComponentWithConsumer;
exports.defaultHorizontalStrength = defaultHorizontalStrength;
exports.defaultVerticalStrength = defaultVerticalStrength;